export interface AnimeItem {
  id: string;
  title: string;
  titleEn: string;
  cover: string;
  category: string;
  rating: number;
  episode: string;
  views: string;
  description: string;
  tags: string[];
  year: number;
  status: string;
  region: string;
  studio: string;
  episodes: string[];
}

export interface NbaVideo {
  id: string;
  title: string;
  cover: string;
  date: string;
  views: string;
  duration: string;
  teams: string;
}

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  role: string;
  content: string;
  rating: number;
}

export const featuredAnime: AnimeItem[] = [
  {
    id: 'anime-1',
    title: '咒术回战 第三季',
    titleEn: 'Jujutsu Kaisen S3',
    cover: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20poster%20dark%20theme%20with%20character%20using%20cursed%20energy%20glowing%20red%20and%20black%20atmosphere%20dramatic%20lighting%20action%20scene%20minimalist%20clean%20background%20professional%20anime%20art%20style%20with%20Japanese%20text&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    category: '热血',
    rating: 9.7,
    episode: '更新至第8话',
    views: '12.6亿',
    description: '虎杖悠仁与伙伴们迎来更加残酷的战斗，宿傩的真正计划逐渐浮出水面。咒术界的终极对决即将展开。',
    tags: ['热血', '战斗', '黑暗奇幻'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'MAPPA',
    episodes: ['第1话 诅咒之子', '第2话 暗流涌动', '第3话 觉醒时刻', '第4话 破灭的序章', '第5话 终焉的预言', '第6话 命运交汇', '第7话 决战前夕', '第8话 终极力量', '第9话 (待更新)', '第10话 (待更新)'],
  },
  {
    id: 'anime-2',
    title: '葬送的芙莉莲 第二季',
    titleEn: 'Sousou no Frieren S2',
    cover: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20poster%20elf%20mage%20with%20silver%20hair%20in%20fantasy%20landscape%20golden%20sunset%20light%20melancholic%20atmosphere%20beautiful%20detailed%20illustration%20soft%20colors%20clean%20background%20professional%20anime%20art&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    category: '冒险',
    rating: 9.8,
    episode: '更新至第12话',
    views: '8.3亿',
    description: '魔法使芙莉莲踏上新的旅程，追寻人类与精灵之间跨越时间的羁绊。感动与冒险交织的奇幻史诗续篇。',
    tags: ['冒险', '奇幻', '治愈'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'MADHOUSE',
    episodes: ['第1话 新的旅途', '第2话 北方的遗迹', '第3话 魔法之书', '第4话 回忆中的味道', '第5话 旅伴', '第6话 精灵的传说', '第7话 沉睡的古城', '第8话 试炼之门', '第9话 昔日的英雄', '第10话 冰封的记忆', '第11话 觉醒', '第12话 重逢之时'],
  },
  {
    id: 'anime-3',
    title: '鬼灭之刃 无限城篇',
    titleEn: 'Demon Slayer: Infinity Castle',
    cover: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20character%20with%20sword%20in%20dark%20infinity%20castle%20scene%20red%20and%20black%20color%20scheme%20dynamic%20action%20pose%20flame%20effects%20dramatic%20lighting%20professional%20anime%20style%20clean%20dark%20background&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    category: '热血',
    rating: 9.9,
    episode: '更新至第5话',
    views: '18.2亿',
    description: '炭治郎与鬼杀队突入无限城，与上弦之鬼的最终决战拉开帷幕。命运的交织与牺牲将撼动整个鬼灭世界。',
    tags: ['热血', '战斗', '历史奇幻'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'ufotable',
    episodes: ['第1话 无限城', '第2话 上弦集结', '第3话 水之呼吸·终式', '第4话 兄妹的羁绊', '第5话 火之神乐', '第6话 (待更新)'],
  },
];

export const hotAnime: AnimeItem[] = [
  {
    id: 'anime-4',
    title: '我推的孩子 第二季',
    titleEn: 'Oshi no Ko S2',
    cover: 'https://readdy.ai/api/search-image?query=Oshi%20no%20Ko%20season%202%20anime%20poster%20idol%20theme%20with%20star%20eyes%20character%20in%20spotlight%20stage%20performance%20scene%20dramatic%20purple%20and%20pink%20atmosphere%20professional%20anime%20art%20style%20clean%20background&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    category: '剧情',
    rating: 9.5,
    episode: '更新至第11话',
    views: '7.8亿',
    description: '星野爱的秘密逐渐揭开，娱乐圈的黑暗与光芒交织。新一代偶像的成长故事继续上演。',
    tags: ['剧情', '偶像', '悬疑'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: '动画工房',
    episodes: ['第1话 新生', '第2话 舞台之上', '第3话 真实的代价', '第4话 双子星', '第5话 暗中较量', '第6话 偶像之路', '第7话 选秀日', '第8话 B小町复活', '第9话 危机', '第10话 守护的誓言', '第11话 光芒万丈'],
  },
  {
    id: 'anime-5',
    title: '进击的巨人 终章·后篇',
    titleEn: 'Attack on Titan Final Arc',
    cover: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20final%20season%20anime%20poster%20colossal%20titan%20in%20apocalyptic%20scene%20orange%20sky%20destruction%20dramatic%20composition%20dark%20atmosphere%20professional%20anime%20art%20cinematic%20quality%20clean%20background&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    category: '热血',
    rating: 9.8,
    episode: '全12话完结',
    views: '22.1亿',
    description: '地鸣发动后的最终决战。艾伦、三笠、阿尔敏的命运将走向何方？震撼世界的终结篇。',
    tags: ['热血', '黑暗奇幻', '战争'],
    year: 2026,
    status: '已完结',
    region: '日本',
    studio: 'MAPPA',
    episodes: ['第1话 地鸣', '第2话 自由之翼', '第3话 最后的城墙', '第4话 代价', '第5话 始祖之力', '第6话 绝望中的希望', '第7话 决战', '第8话 诀别', '第9话 终局', '第10话 自由的代价', '第11话 漫长的一天', '第12话 致两千年后的你'],
  },
  {
    id: 'anime-6',
    title: '间谍过家家 第三季',
    titleEn: 'Spy x Family S3',
    cover: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20season%203%20anime%20poster%20family%20of%20three%20in%20stylish%20outfits%20warm%20color%20palette%20playful%20atmosphere%20elegant%20living%20room%20setting%20professional%20anime%20art%20style%20clean%20background&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    category: '搞笑',
    rating: 9.6,
    episode: '更新至第10话',
    views: '15.4亿',
    description: '福杰一家的日常还在继续！新的任务、新的挑战，这个"伪装家庭"的羁绊越来越深厚。',
    tags: ['搞笑', '日常', '间谍'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'WIT STUDIO × CloverWorks',
    episodes: ['第1话 新学期', '第2话 约尔的秘密任务', '第3话 安妮亚的校园生活', '第4话 邦德的冒险', '第5话 家庭露营', '第6话 新邻居', '第7话 黄昏的过去', '第8话 危机四伏', '第9话 守护', '第10话 真正的家人'],
  },
  {
    id: 'anime-7',
    title: '海贼王 和之国篇完结',
    titleEn: 'One Piece: Wano Finale',
    cover: 'https://readdy.ai/api/search-image?query=One%20Piece%20Wano%20arc%20anime%20poster%20Luffy%20gear%205%20transformation%20in%20epic%20battle%20Japanese%20castle%20setting%20dynamic%20action%20white%20and%20red%20color%20theme%20professional%20anime%20art%20cinematic&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    category: '热血',
    rating: 9.9,
    episode: '更新至第1128话',
    views: '35.7亿',
    description: '和之国决战达到高潮，路飞觉醒尼卡形态，与凯多的最终对决震撼天地。新时代的序幕正式拉开。',
    tags: ['热血', '冒险', '战斗'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: '东映动画',
    episodes: ['第1120话 尼卡觉醒', '第1121话 太阳神', '第1122话 凯多的末日', '第1123话 和之国的黎明', '第1124话 新四皇诞生', '第1125话 全员集结', '第1126话 绿牛来袭', '第1127话 庆典', '第1128话 再启航'],
  },
  {
    id: 'anime-8',
    title: '孤独摇滚 第二季',
    titleEn: 'Bocchi the Rock! S2',
    cover: 'https://readdy.ai/api/search-image?query=Bocchi%20the%20Rock%20season%202%20anime%20poster%20girl%20with%20guitar%20in%20band%20performance%20stage%20colorful%20concert%20lighting%20pink%20and%20blue%20atmosphere%20cute%20art%20style%20professional%20anime%20clean%20background&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    category: '日常',
    rating: 9.3,
    episode: '更新至第9话',
    views: '5.2亿',
    description: '后藤一里的摇滚之路继续！结束乐队的音乐旅程迎来了新的挑战与舞台。社恐少女的成长物语。',
    tags: ['日常', '音乐', '搞笑'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'CloverWorks',
    episodes: ['第1话 新学期Live', '第2话 新曲制作', '第3话 音乐节', '第4话 粉丝见面会', '第5话 一里的烦恼', '第6话 乐队危机', '第7话 突破', '第8话 全国巡演', '第9话 舞台之上'],
  },
  {
    id: 'anime-9',
    title: '五等分的新娘 最终季',
    titleEn: 'The Quintessential Quintuplets Finale',
    cover: 'https://readdy.ai/api/search-image?query=Quintessential%20Quintuplets%20anime%20poster%20five%20cute%20girls%20in%20school%20uniforms%20pastel%20colors%20cherry%20blossom%20background%20romantic%20comedy%20style%20professional%20anime%20art%20clean&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    category: '恋爱',
    rating: 9.4,
    episode: '全12话完结',
    views: '6.8亿',
    description: '上杉风太郎与五姐妹的故事迎来最终章。究竟谁能赢得他的心？甜蜜与感动交织的恋爱物语最终话。',
    tags: ['恋爱', '校园', '喜剧'],
    year: 2026,
    status: '已完结',
    region: '日本',
    studio: 'Bibury Animation',
    episodes: ['第1话 最后的考试', '第2话 毕业旅行', '第3话 告白', '第4话 选择', '第5话 新婚', '第6话 蜜月的开始', '第7话 婚礼准备', '第8话 姐妹的羁绊', '第9话 幸福的答案', '第10话 过去与未来', '第11话 大家的祝福', '第12话 终幕'],
  },
  {
    id: 'anime-10',
    title: '新世纪福音战士 终章',
    titleEn: 'Neon Genesis Evangelion Final',
    cover: 'https://readdy.ai/api/search-image?query=Evangelion%20anime%20poster%20giant%20mecha%20robot%20in%20futuristic%20cityscape%20dramatic%20lighting%20purple%20and%20green%20color%20scheme%20cyberpunk%20atmosphere%20professional%20anime%20art%20clean%20background&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    category: '科幻',
    rating: 9.9,
    episode: '全6话完结',
    views: '10.1亿',
    description: '碇真嗣与EVA驾驶员们面对人类补完计划的最终阶段。科幻与哲学的巅峰之作迎来史诗结局。',
    tags: ['科幻', '机战', '心理'],
    year: 2026,
    status: '已完结',
    region: '日本',
    studio: 'Khara',
    episodes: ['第1话 莉莉丝', '第2话 使徒来袭', '第3话 人类的反击', '第4话 补完计划', '第5话 最后的战斗', '第6话 新世纪'],
  },
  {
    id: 'anime-11',
    title: '夏日重现',
    titleEn: 'Summer Time Rendering',
    cover: 'https://readdy.ai/api/search-image?query=Summer%20Time%20Rendering%20anime%20poster%20mysterious%20island%20scene%20dark%20atmosphere%20time%20loop%20mystery%20suspense%20blue%20and%20dark%20tones%20professional%20anime%20art%20clean%20background&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    category: '悬疑',
    rating: 9.6,
    episode: '全25话完结',
    views: '4.5亿',
    description: '网代慎平返回故乡参加葬礼，却陷入了时间循环的诡异事件。悬疑推理与时间穿越的绝妙结合。',
    tags: ['悬疑', '推理', '超自然'],
    year: 2026,
    status: '已完结',
    region: '日本',
    studio: 'OLM',
    episodes: ['第1话 影子', '第2话 欢迎回来', '第3话 循环', '第4话 潮的遗物', '第5话 慎平的推理', '第6话 波稻', '第7话 暗影', '第8话 平行世界', '第9话 四手', '第10话 对决'],
  },
  {
    id: 'anime-12',
    title: '青之芦苇 第二季',
    titleEn: 'Ao Ashi S2',
    cover: 'https://readdy.ai/api/search-image?query=Ao%20Ashi%20soccer%20anime%20poster%20football%20player%20in%20green%20jersey%20dynamic%20action%20sports%20stadium%20lighting%20green%20grass%20field%20professional%20anime%20art%20style%20clean%20background&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    category: '运动',
    rating: 9.5,
    episode: '更新至第15话',
    views: '3.9亿',
    description: '青井苇人继续他在东京城市队的足球生涯。从替补到主力，少年在绿茵场上不断突破自我。',
    tags: ['运动', '足球', '青春'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'Production I.G',
    episodes: ['第1话 新赛季', '第2话 位置争夺', '第3话 战术理解', '第4话 队友的信任', '第5话 德比战', '第6话 逆风', '第7话 转型', '第8话 觉醒的视野', '第9话 天才的困境', '第10话 再起动', '第11话 决战', '第12话 绝处逢生', '第13话 新战术', '第14话 最后一秒', '第15话 胜利之味'],
  },
  {
    id: 'anime-13',
    title: 'NANA 重启版',
    titleEn: 'NANA Reboot',
    cover: 'https://readdy.ai/api/search-image?query=NANA%20punk%20rock%20anime%20poster%20two%20stylish%20women%20with%20guitars%20dark%20aesthetic%20black%20clothes%20dramatic%20urban%20nightlife%20setting%20professional%20anime%20art%20clean%20background&width=600&height=840&seq=anime-cover-13&orientation=portrait',
    category: '音乐',
    rating: 9.4,
    episode: '更新至第7话',
    views: '3.2亿',
    description: '大崎娜娜与小松奈奈的故事以全新画面重启。摇滚乐、梦想与友谊交织的青春物语。',
    tags: ['音乐', '摇滚', '情感'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'Madhouse',
    episodes: ['第1话 再一次', '第2话 相遇', '第3话 乐队组建', '第4话 首场演出', '第5话 签约', '第6话 冲突', '第7话 成名之路'],
  },
  {
    id: 'anime-14',
    title: '命运石之门 0 续篇',
    titleEn: 'Steins;Gate 0 Continuation',
    cover: 'https://readdy.ai/api/search-image?query=Steins%20Gate%20anime%20poster%20time%20travel%20laboratory%20scene%20mad%20scientist%20character%20dramatic%20blue%20and%20orange%20lighting%20futuristic%20atmosphere%20professional%20anime%20art%20clean%20background&width=600&height=840&seq=anime-cover-14&orientation=portrait',
    category: '科幻',
    rating: 9.7,
    episode: '更新至第6话',
    views: '5.1亿',
    description: '冈部伦太郎在β世界线中继续寻找拯救牧瀬红莉栖的方法。时间机器的伦理与命运再次交织。',
    tags: ['科幻', '时间旅行', '悬疑'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: 'White Fox',
    episodes: ['第1话 世界线的选择', '第2话 时间的代价', '第3话 零的思念', '第4话 时间跳跃', '第5话 对抗机关', '第6话 新希望'],
  },
  {
    id: 'anime-15',
    title: '冰菓 第二季',
    titleEn: 'Hyouka S2',
    cover: 'https://readdy.ai/api/search-image?query=Hyouka%20anime%20poster%20school%20mystery%20student%20in%20school%20uniform%20cherry%20blossom%20spring%20atmosphere%20warm%20pastel%20colors%20peaceful%20detective%20style%20professional%20anime%20art%20clean&width=600&height=840&seq=anime-cover-15&orientation=portrait',
    category: '恋爱',
    rating: 9.3,
    episode: '更新至第5话',
    views: '2.8亿',
    description: '古典文学部再次迎来新的谜题。折木奉太郎与千反田爱瑠的关系也悄然发生着变化。',
    tags: ['恋爱', '校园', '推理'],
    year: 2026,
    status: '连载中',
    region: '日本',
    studio: '京都动画',
    episodes: ['第1话 新的委托', '第2话 学园祭的准备', '第3话 谜团再现', '第4话 爱瑠的邀请', '第5话 节能主义的终结'],
  },
];

export const nbaVideos: NbaVideo[] = [
  {
    id: 'nba-1',
    title: '湖人 vs 勇士 全场集锦 | 詹姆斯三双率队逆转',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20Lakers%20vs%20Warriors%20intense%20action%20scene%20purple%20and%20gold%20jersey%20vs%20blue%20and%20yellow%20dramatic%20stadium%20lighting%20sports%20photography%20professional%20clean%20background&width=800&height=450&seq=nba-cover-01&orientation=landscape',
    date: '2026-07-06',
    views: '892万',
    duration: '12:35',
    teams: '湖人 vs 勇士',
  },
  {
    id: 'nba-2',
    title: '季后赛东部决赛G7 凯尔特人 vs 雄鹿 决胜时刻',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20playoff%20game%207%20Celtics%20vs%20Bucks%20intense%20basketball%20action%20green%20jersey%20dramatic%20arena%20atmosphere%20championship%20moment%20sports%20photography%20professional%20clean&width=800&height=450&seq=nba-cover-02&orientation=landscape',
    date: '2026-07-05',
    views: '1200万',
    duration: '18:22',
    teams: '凯尔特人 vs 雄鹿',
  },
  {
    id: 'nba-3',
    title: '文班亚马单场45分15篮板 马刺新星闪耀全场',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20Wembanyama%20dunking%20highlight%20Spurs%20jersey%20silver%20and%20black%20dynamic%20pose%20arena%20lights%20sports%20photography%20dramatic%20angle%20professional%20clean&width=800&height=450&seq=nba-cover-03&orientation=landscape',
    date: '2026-07-04',
    views: '1560万',
    duration: '08:45',
    teams: '马刺 vs 雷霆',
  },
  {
    id: 'nba-4',
    title: '2026 NBA总决赛G3 全场回放 | 掘金主场迎战',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20Finals%202026%20Denver%20Nuggets%20home%20game%20championship%20basketball%20intense%20action%20navy%20blue%20jersey%20packed%20arena%20dramatic%20lighting%20sports%20photography&width=800&height=450&seq=nba-cover-04&orientation=landscape',
    date: '2026-07-03',
    views: '2300万',
    duration: '45:10',
    teams: '掘金 vs 76人',
  },
  {
    id: 'nba-5',
    title: '库里10记三分引爆全场 勇士大胜太阳',
    cover: 'https://readdy.ai/api/search-image?query=Stephen%20Curry%20three%20pointer%20shot%20Warriors%20jersey%20celebration%20moment%20basketball%20arena%20golden%20confetti%20dramatic%20lighting%20sports%20photography%20professional%20clean%20background&width=800&height=450&seq=nba-cover-05&orientation=landscape',
    date: '2026-07-02',
    views: '980万',
    duration: '10:15',
    teams: '勇士 vs 太阳',
  },
];

export const categories = [
  {
    slug: 'reboot',
    name: '热血动漫',
    icon: 'ri-fire-line',
    color: 'primary',
    description: '燃爆全场的战斗与冒险',
    count: 1280,
  },
  {
    slug: 'love',
    name: '恋爱动漫',
    icon: 'ri-heart-line',
    color: 'accent',
    description: '甜蜜温馨的恋爱故事',
    count: 890,
  },
  {
    slug: 'funny',
    name: '搞笑动漫',
    icon: 'ri-emotion-laugh-line',
    color: 'secondary',
    description: '轻松愉快的搞笑日常',
    count: 756,
  },
  {
    slug: 'sci-fi',
    name: '科幻动漫',
    icon: 'ri-rocket-line',
    color: 'secondary',
    description: '未来世界的无限想象',
    count: 523,
  },
  {
    slug: 'horror',
    name: '悬疑动漫',
    icon: 'ri-ghost-line',
    color: 'primary',
    description: '扣人心弦的悬疑推理',
    count: 412,
  },
  {
    slug: 'sports',
    name: '运动动漫',
    icon: 'ri-basketball-line',
    color: 'accent',
    description: '热血澎湃的体育竞技',
    count: 345,
  },
  {
    slug: 'music',
    name: '音乐动漫',
    icon: 'ri-music-line',
    color: 'secondary',
    description: '旋律交织的音乐世界',
    count: 278,
  },
  {
    slug: 'nba',
    name: 'NBA赛事',
    icon: 'ri-trophy-line',
    color: 'primary',
    description: '精彩NBA赛事视频',
    count: 1560,
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '小明同学',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20portrait%20friendly%20smile%20clean%20simple%20background%20illustration%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '忠实用户 · 追番3年',
    content: '从大学开始就用51动漫追番了，真的完全免费！画质高清，更新速度也超快。每次新番开播第一时间就能看到，比别的平台快多了。强烈推荐给所有动漫爱好者！',
    rating: 5,
  },
  {
    id: 't-2',
    name: '篮球少年阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Basketball%20player%20anime%20style%20boy%20avatar%20energetic%20portrait%20clean%20simple%20background%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: 'NBA球迷 · 使用2年',
    content: '本来是来找NBA回放的，结果发现这里动漫资源也超级全！现在每天打开51动漫已经成了习惯。NBA赛事更新很及时，画质也很棒。',
    rating: 5,
  },
  {
    id: 't-3',
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20pink%20hair%20cute%20portrait%20clean%20simple%20background%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '动漫博主 · 资深用户',
    content: '作为一个看了十几年动漫的老粉，51动漫的资源库真的让我惊喜。冷门番也能找到，而且没有任何广告弹窗。界面简洁好用，看番体验超棒！',
    rating: 5,
  },
];

export const latestNews = [
  {
    id: 'news-1',
    title: '2026年7月新番导览：盛夏必看的十大动漫推荐',
    date: '2026-07-06',
    summary: '七月新番即将开播，从热血战斗到治愈日常，本期为你盘点最值得追的夏季新番，帮你规划追番日历。',
    cover: 'https://readdy.ai/api/search-image?query=Summer%20anime%20season%202026%20collage%20of%20various%20new%20anime%20characters%20colorful%20vibrant%20warm%20summer%20vibe%20clean%20composition%20professional%20illustration%20style&width=600&height=340&seq=news-cover-01&orientation=landscape',
    category: '动漫资讯',
  },
  {
    id: 'news-2',
    title: '鬼灭之刃无限城篇票房突破500亿日元',
    date: '2026-07-05',
    summary: '剧场版《鬼灭之刃 无限城篇》上映三周票房突破500亿日元，刷新日本影史多项纪录，全球票房持续攀升。',
    cover: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20movie%20box%20office%20success%20celebration%20visual%20Japanese%20anime%20movie%20poster%20style%20dark%20red%20atmosphere%20dramatic&width=600&height=340&seq=news-cover-02&orientation=landscape',
    category: '动漫资讯',
  },
  {
    id: 'news-3',
    title: 'NBA总决赛G4前瞻：掘金能否在主场锁定胜局？',
    date: '2026-07-06',
    summary: '2026年NBA总决赛第四战即将在丹佛主场打响，掘金3-0手握赛点，76人绝境求生，精彩不容错过。',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20Finals%20preview%20Denver%20Nuggets%20championship%20basketball%20court%20dramatic%20stadium%20lighting%20professional%20sports%20photography&width=600&height=340&seq=news-cover-03&orientation=landscape',
    category: 'NBA资讯',
  },
];